import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="mb-20 lg:mb-28" data-id="element-58">
      <div className="mb-10 lg:mb-14 text-center" data-id="element-59">
        <span className="inline-block text-xs lg:text-sm font-bold tracking-widest text-[#1B6B3A] uppercase mb-5 border-b border-[#1B6B3A] pb-1" data-id="element-60">
          Closing Number Lock
        </span>
        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif font-bold text-[#1A1A1A] leading-[1.1] mb-6 lg:mb-8" data-id="element-61">
          Stop the 48‑hour
          <br className="hidden sm:block" data-id="element-62" /> closing surprise.
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-[#3D3D3D] font-serif italic leading-relaxed max-w-2xl mx-auto" data-id="element-63">
          The Lender–Title–Insurance Coordination Checklist That Stops
          Last‑Minute Cash‑to‑Close Surprises
        </p>
      </div>

      <div className="my-12 lg:my-16 relative group max-w-2xl mx-auto" data-id="element-64">
        <div className="absolute inset-0 bg-[#1B6B3A]/5 rounded-xl transform rotate-1 scale-105 transition-transform duration-500 group-hover:rotate-2 group-hover:scale-105" data-id="element-65" />
        <img src="https://cdn.magicpatterns.com/uploads/iNPwTpXDyU9FvTQpX48zLU/heylloyd-image-1770951032391.png" alt="Closing Number Lock Digital Guide on Tablet" className="relative rounded-lg shadow-xl w-full h-auto transform transition-transform duration-500 hover:-translate-y-1" data-id="element-66" />
      </div>

      <div className="max-w-2xl mx-auto" data-id="element-67">
        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-5 lg:mb-6" data-id="element-68">
          The worst part isn't paying closing costs.
        </p>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-5 lg:mb-6" data-id="element-69">
          The worst part is believing you've planned correctly…
        </p>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-8 lg:mb-10" data-id="element-70">
          and then getting the message two days before closing:
        </p>

        <div className="bg-[#F0F7F2] border-l-4 border-[#1B6B3A] p-6 lg:p-8 my-8 lg:my-10 rounded-r-lg" data-id="element-71">
          <p className="text-2xl lg:text-3xl font-serif font-bold text-[#1B6B3A] m-0" data-id="element-72">
            "Your cash-to-close changed."
          </p>
        </div>
      </div>
    </motion.section>;
}